<template>
    <CCard>
        <CCardBody>
            <CContainer class="section" fluid>
                <CRow class="border-bottom">
                    <CCol md="10">
                        <h2 class="section__title my-4">
                            {{ $t("origins") }}
                        </h2>
                    </CCol>
                    <CCol md="2">
                        <div
                            class="btn-wrapper btn-wrapper__end-center"
                        >
                            <ButtonCreate
                                @click="
                                    openModal({
                                        modalName: 'addOrigin',
                                        data: {
                                            provider,
                                        },
                                    })
                                "
                            >
                                {{ $t("add_origin") }}
                            </ButtonCreate>
                        </div>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CDataTable
                            :addTableClasses="['table--sm']"
                            :fields="
                                traslateArrayObjects({
                                    array: tables.origins.fields,
                                    fields: ['label'],
                                })
                            "
                            :items="tables.origins.items"
                            :columnFilterValue.sync="
                                tables.origins.columnFilterValue
                            "
                            :loading="tables.origins.loading"
                            :sorterValue.sync="tables.origins.sorterValue"
                            @update:column-filter-value="updateData()"
                            @update:sorter-value="updateData()"
                            @pagination-change="itemPerPage"
                            :items-per-page="tables.origins.rows"
                            v-bind="tables.origins"
                        >
                            <template #over-table>
                                <CContainer :fluid="true" class="mb-2">
                                    <CRow alignHorizontal="start">
                                        <CDropdown
                                            color="primary"
                                            :toggler-text="$t('actions')"
                                            :disabled="
                                                tables.origins.itemSelected ===
                                                null
                                            "
                                        >
                                            <CDropdownItem
                                                tag="div"
                                                @click="
                                                    deleteOrigin(
                                                        tables.origins
                                                            .itemSelected
                                                    )
                                                "
                                            >
                                                {{ $t("delete") }}
                                            </CDropdownItem>
                                        </CDropdown>
                                    </CRow>
                                </CContainer>
                            </template>
                            <template #_selected="{ item }">
                                <td class="py-2">
                                    <CInputRadio
                                        name="_selected"
                                        :checked="
                                            item === tables.origins.itemSelected
                                        "
                                        @update:checked="
                                            selectItemTable('origins', item)
                                        "
                                    />
                                </td>
                            </template>
                            <template #no-items-view>
                                <div class="block-no-items section">
                                    <h2 class="section__title text-no-items">
                                        {{ $t("add_origin") }}
                                    </h2>
                                    <CButton
                                        color="success"
                                        class="button m-2 shadow"
                                        @click="
                                            openModal({
                                                modalName: 'addOrigin',
                                                data: {
                                                    provider,
                                                },
                                            })
                                        "
                                    >
                                        <span class="button__icon">
                                            <CIcon
                                                :content="
                                                    $options.icons.cilPlus
                                                "
                                            />
                                        </span>
                                        <span class="button__text">
                                            {{ $t("add_origin") }}
                                        </span>
                                    </CButton>
                                </div>
                            </template>
                            <template #under-table>
                                <div class="d-flex justify-content-end">
                                    <ButtonExport
                                        :endPoint="
                                            '/providers.api/groups/' +
                                            provider.uuid +
                                            '/origins'
                                        "
                                        :table="tables.origins"
                                    />
                                </div>
                            </template>
                        </CDataTable>
                        <div class="position-relative">
                            <CPagination
                                @update:activePage="updatePagination"
                                :activePage="tables.origins.page"
                                :pages="tables.origins.total_pages"
                                align="center"
                            />
                            <CElementCover
                                :opacity="0.8"
                                class="bg-trasparent"
                                v-if="tables.origins.loading"
                            />
                        </div>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <ProviderAddOriginModal
            v-bind="modals.addOrigin"
            :show.sync="modals.addOrigin.show"
            v-on:submit="updateData"
        />
    </CCard>
</template>

<script>
/** Components */
import ButtonLoading from "~/components/ButtonLoading.vue";
import ProviderAddOriginModal from "~/pages/app/Providers/Components/ProviderAddOriginModal.vue";
import ButtonExport from "~/components/ButtonExport";
import ButtonCreate from "~/components/ButtonCreate";

/** Mixins */
import { validationMixin } from "vuelidate";
import tableMixin from "~/mixins/table";
import modalMixin from "~/mixins/modal";
import traslateMixin from "~/mixins/traslate.js";

/** Others */

import {
    cilPencil,
    cilCaretBottom,
    cilCaretTop,
    cilSave,
    cilPlus,
    cilTrash,
} from "@coreui/icons";

export default {
    name: "ProviderViewOriginsTab",
    mixins: [validationMixin, traslateMixin, tableMixin, modalMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
        cilPlus,
        cilTrash,
    },

    components: {
        ButtonLoading,
        ProviderAddOriginModal,
        ButtonExport,
        ButtonCreate,
    },

    props: {
        provider: {
            type: Object,
        },
        loading: Boolean,
    },

    data() {
        return {
            tables: {
                origins: {
                    items: [],
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            fixed: true,
                            sortable: false,
                            filter: false,
                            _filter: false,
                            _style: "width:5%",
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            _style: "width:10%",
                        },
                        {
                            label: "origin",
                            key: "origin",
                            filter: true,
                            _filter: true,
                        },
                        {
                            label: "created_at",
                            key: "created_at",
                            filter: false,
                            _filter: false,
                        },
                    ],
                    allFields: [],
                    order: "desc",
                    total_pages: 0,
                    loading: true,
                    rows: 10,
                    page: 1,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
            modals: {
                addOrigin: {
                    show: false,
                    color: "primary",
                    title: "add_origin",
                    data: {
                        provider: null,
                    },
                },
            },
        };
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "origins",
                url: `/providers.api/groups/${this.provider.uuid}/origins`,
            });
            this.tables.origins.loading = false;
        },
        deleteOrigin: async function (item) {
            try {
                await this.deleteData({
                    url: `/providers.api/groups/${this.provider.uuid}/origins/${item.origin}/delete`,
                });
                await this.updateData();
            } catch (error) {
                this.showMessageError(error);
            }
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style>
</style>